var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-attachment",
  "use": "ring-icon-attachment-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-attachment\"><path d=\"M13.62 8.07L6.48 1l-1 1 7.13 7.07a3.19 3.19 0 0 1 1 2 2.37 2.37 0 0 1-.68 1.93 2.43 2.43 0 0 1-1.87.65 3.21 3.21 0 0 1-2.06-1l-1-.94-5.3-5.29a1 1 0 0 1 0-1.36 1 1 0 0 1 1.38 0l6.76 6.7 1-1L5 4.1a2.41 2.41 0 0 0-3.36 0 2.35 2.35 0 0 0 0 3.33l.63.57L8 13.63A4.63 4.63 0 0 0 11 15h.26A3.68 3.68 0 0 0 15 11a4.54 4.54 0 0 0-1.38-2.93z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id